


























import CRichTextEditor from '~/components/shared/configurable/form/rich-text/CRichTextEditor.vue'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import Heading from '@tiptap/extension-heading'
import ListItem from '@tiptap/extension-list-item'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import History from '@tiptap/extension-history'
import Placeholder from '@tiptap/extension-placeholder'
import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { useMultiLanguagesForm } from '~/compositions/form/multi-language'
import { formFieldProps } from '~/constants/form'
import { computeFieldState } from '~/utils/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { useI18n } from '~/compositions/i18n'
import FieldLanguagePicker from '~/components/car/classifieds/form/fieldsets/fields/FieldLanguagePicker.vue'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { Ref } from '@vue/composition-api'
export default defineComponent({
  components: {
    FieldLanguagePicker,
    FieldError,
    CRichTextEditor
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name, fieldValue } = toRefs(props)
    const { t } = useI18n()

    const languagesSpecs = computed(
      () =>
        specs.value?.languages || {
          el: { required: true },
          en: { required: false }
        }
    )
    const {
      errors,
      values,
      onError,
      onValue: onMultiLanguageValue,
      currentLanguage
    } = useMultiLanguagesForm(languagesSpecs.value)

    const onValue = (v: Ref<any>) => {
      // When onMultiLanguageValue runs the cursor changes because we use setContent for tiptap
      // so only run it when the changes from the server are not the same as the local fieldValues

      let isSame = false
      Object.keys(languagesSpecs.value).forEach(lang => {
        if (
          (fieldValue.value && fieldValue.value[lang]) ||
          (v.value && v.value[lang])
        ) {
          isSame =
            Boolean(values.value[lang]) &&
            JSON.stringify(fieldValue.value[lang]) ===
              JSON.stringify(v.value[lang])
        }
      })

      if (!isSame) {
        onMultiLanguageValue(v)
      }
    }
    const { debouncedValueChanged } = useClassifiedForm(props, {
      onValue,
      onError
    })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const placeholder = computed(() => specs.value?.placeholder)

    const currentLanguageError = computed(
      () => errors.value[currentLanguage.value]
    )
    const currentLanguageValue = computed(
      () => values.value[currentLanguage.value]
    )
    const currentLanguageIsRequired = computed(
      () => languagesSpecs.value[currentLanguage.value].required
    )
    const currentLanguageIsValid = computed(() =>
      computeFieldState(errors.value[currentLanguage.value])
    )
    const availableLanguages = computed(() => Object.keys(languagesSpecs.value))

    const extensions = computed(() => [
      Bold,
      Italic,
      Underline,
      Heading,
      ListItem,
      BulletList,
      OrderedList,
      History,
      Placeholder.configure({
        placeholder: specs.value?.placeholder || t('text'),
        showOnlyWhenEditable: true
      })
    ])

    const handleEditorInput = ({ json, text }) => {
      errors.value[currentLanguage.value] = formValidationBuilder
        .new()
        .required(currentLanguageIsRequired.value, text)
        .validate()
      debouncedValueChanged(name.value, json, {
        multilingual: {
          abbreviation: currentLanguage.value
        }
      })
    }

    const setCurrentLanguage = (lang: string) => {
      currentLanguage.value = lang
    }
    const getLanguageValue = (lang: string) => {
      return values.value[lang] || null
    }

    return {
      currentLanguageValue,
      currentLanguage,
      currentLanguageError,
      extensions,
      handleEditorInput,
      availableLanguages,
      values,
      errors,
      setCurrentLanguage,
      placeholder,
      currentLanguageIsValid,
      getLanguageValue
    }
  }
})
